import { Component, Inject, input, ChangeDetectionStrategy } from '@angular/core';
import { NOTIFICATION_DATA, NotificationData } from '@hypergraph/tapestry';

@Component({
  selector: 'app-notification',
  imports: [],
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './notification.component.scss',
})
export class NotificationComponent {
  type = input.required<'success' | 'error' | 'warning' | 'info'>();

  get title(): string {
    return this.data.title;
  }

  get message(): string {
    return this.data.message;
  }

  constructor(@Inject(NOTIFICATION_DATA) public data: NotificationData) {}
}
